/** Tauri IPC calls are fetches to `ipc://` or `http(s)://ipc.localhost`, not network requests. */

const IPC_HOSTNAME = 'ipc.localhost';

export function isTauriIpcUrl(rawUrl: unknown): boolean {
  if (typeof rawUrl !== 'string') return false;
  try {
    const { protocol, hostname } = new URL(rawUrl);
    return protocol === 'ipc:' || hostname === IPC_HOSTNAME;
  } catch {
    return false;
  }
}

/** True for a RUM resource event that describes a Tauri IPC call. */
export function isTauriIpcResourceEvent(event: {
  type?: unknown;
  resource?: { url?: unknown };
}): boolean {
  return event.type === 'resource' && isTauriIpcUrl(event.resource?.url);
}
